function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M7 0C3.14019 0 0 3.14019 0 7C0 10.8598 3.14019 14 7 14C10.8598 14 14 10.8598 14 7C14 3.14019 10.8597 0 7 0ZM7 12.5257C3.95308 12.5257 1.47422 10.0469 1.47422 7C1.47422 3.95308 3.95308 1.47422 7 1.47422C10.0469 1.47422 12.5258 3.95308 12.5258 7C12.5258 10.0469 10.0469 12.5257 7 12.5257Z",
  fill: "#93A6BB"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M9.91914 7.07734H7.04942V4.5916C7.04942 4.18442 6.71949 3.85449 6.31231 3.85449C5.90513 3.85449 5.5752 4.18442 5.5752 4.5916V7.81445C5.5752 8.22163 5.90513 8.55156 6.31231 8.55156H9.91914C10.3263 8.55156 10.6562 8.22163 10.6562 7.81445C10.6562 7.40727 10.3262 7.07734 9.91914 7.07734Z",
  fill: "#93A6BB"
});

function SvgTimeIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeIcon);
export default __webpack_public_path__ + "static/media/TimeIcon.001a88a7.svg";
export { ForwardRef as ReactComponent };